import React from 'react'
import './iconTitle.scss'

interface MentoriaIconTitleProps {
    text: string;
    src: string;
    width?: number;
}

const MentoriaIconTitle = (props: MentoriaIconTitleProps) => {

    const { text, src, width = 30 } = props;

    return (
        <div className="mentoria-icon-title">
            <img className="mentoria-icon-title__img" src={src} alt={text} width={width} />
            <h3>{text}</h3>
        </div>
    )
}

export default MentoriaIconTitle